import { DropdownNames } from '@/components_deprecated/Select/types'
import { UserOrderBy } from '@/modules/activities'
import { useActivityExportMutations } from '@/modules/activities/mutations.hooks'
import { useCompany, useUser } from '@/utils/hooks'
import { useTranslate } from '@ur-solutions/react-hooks'
import { useState } from 'react'
import { ExportFormat, ExportOption, ExportType } from '../consts'
import type { ExportPeriod } from './export-form'
import {
  ExportCard,
  ExportMethodField,
  ExportPeriodField,
  ExportUsersField,
  getExportPeriodIso,
} from './export-form'

export const ExportRawActivitiesCard: React.FC = () => {
  const translations = useTranslate({
    header: 'exports.raw-activities.title',
    description: 'exports.raw-activities.description',
  })

  const me = useUser()
  const company = useCompany()
  const { exportActivitiesMass, loading } = useActivityExportMutations()

  const [period, setPeriod] = useState<ExportPeriod>(() => ({
    useDateRange: false,
    month: new Date(),
    dateStart: new Date(),
    dateEnd: new Date(),
  }))
  const [users, setUsers] = useState<string[]>([])
  const [exportOption, setExportOption] = useState(ExportOption.SAVE)

  function handleSubmit() {
    const [dateStart, dateEnd] = getExportPeriodIso(period)

    void exportActivitiesMass({
      variables: {
        exportType: ExportType.MASS_RAW_ACTIVITIES,
        exportFormat: ExportFormat.EXCEL,
        exportOption,
        user: me.id,
        users,
        company: company.id,
        dateStart,
        dateEnd,
        orderBy: UserOrderBy.FAMILY_NAME,
        includeAbsences: false,
        weekly: false,
        leaderGroups: [],
      },
    })
  }

  return (
    <ExportCard
      title={translations.header}
      description={translations.description}
      loading={loading}
      submitDisabled={users.length === 0}
      onSubmit={handleSubmit}
    >
      <ExportPeriodField
        value={period}
        onChange={value => setPeriod(prev => ({ ...prev, ...value }))}
      />

      <ExportMethodField value={exportOption} onChange={setExportOption} />

      <ExportUsersField
        value={users}
        dropdownPageName={DropdownNames.ACTIVITIES}
        onChange={setUsers}
      />
    </ExportCard>
  )
}
